<template>
  <div class="home-content pos-r">
    <div class="home-header client-width client-height"></div>
    <img src="../assets/home-logo.png" alt="" class="home-logo pos-a" />
    <img src="../assets/logo.png" alt="" class="page-logo pos-a" />
    <!-- <img src="../assets/start-btn.png" alt="" class="start-btn pos-a dis-b" /> -->
    <div
      class="text-center bg-primary btn-pill paddingv15 c-white page-btn pos-a fs-18"
      @click="submit"
    >
      进入活动
    </div>
  </div>
</template>
<script>
export default {
  name: "Home",
  data: () => ({}),
  methods: {
    submit() {
      let phone = localStorage.getItem("PHONE");
      if (phone) {
        this.$router.push({
          name: "About",
        });
      } else {
        this.$router.push({
          name: "Login",
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.home-content {
  width: 100%;
  height: 100vh;
  background: #fffaf0 url(../assets/bg-page.png) center bottom no-repeat;
  background-size: cover;
}
.home-header {
  background: url(../assets/bg-page-header.png) center top no-repeat;
  background-size: cover;
}
.page-logo {
  top: 110px;
  left: 6px;
  width: 323px;
  height: 82px;
}
.start-btn {
  width: 200px;
  bottom: 30px;
  height: 60px;
  left: 50%;
  transform: translateX(-50%);
}
.page-btn {
  width: 255px;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
